import { render } from "./Sponsor.vue?vue&type=template&id=bc3bc3d0&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"

import "./Sponsor.vue?vue&type=style&index=0&id=bc3bc3d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3bc3d0"]])

export default __exports__